<ng-container *ngFor="let name of names">
    <aa-routlet [name]="name"></aa-routlet>
</ng-container>
